<div *ngIf="this.storeData == false" class="overlay">
  <mat-progress-spinner
    class="spinner"
    [color]="color"
    [mode]="mode"
    [value]="value"
    diameter="50"
    *ngIf="this.storeData == false"
  ></mat-progress-spinner>
</div>
<div class="container">
  <div>
    <span class="walletHeading mb-2"> Gemini Wallet </span>
    <div class="row mt-2">
      <div class="col-sm-12 col-md-12 col-lg-4">
        <mat-card class="walletSection d-flex justify-content-between p-3 mb-4">
          <div class="p-0 mt-1">
            <mat-card-title class="amountText p-0 m-0">
              Total Amount
            </mat-card-title>
            <mat-card-subtitle class="totalAmount p-0 m-0">
              ₹ {{ geminiWalletAmount | numberFormatter}}
            </mat-card-subtitle>
          </div>
          <div class="walletImg p-0 m-0">
            <img
              src="assets/images/totalAmount.svg"
              class="img-fluid"
              alt=""
            />
          </div>
        </mat-card>
      </div>

      <div class="col-sm-12 col-md-12 col-lg-8">
        <mat-card class="progressBar p-3 mb-4">
          <div class="d-flex justify-content-between">
            <mat-card-title class="barHead p-0">
              Amount Distribution</mat-card-title
            >
            <mat-card-content class="d-flex mt-2 align-items-center justify-content-center">
              <div class="green-circle ml-2"></div>
              <span class="barElement ml-1">Available</span>
              <div class="blue-circle ml-2"></div>
              <span class="barElement ml-1">Used</span>
              <div class="grey-circle ml-2"></div>
              <span class="barElement ml-1">Expired</span>
            </mat-card-content>
          </div>

          <div class="d-flex">
            <div class="minMaxWidth" [ngStyle]="{'width':availablePercent+'%'}">{{availablePercent}}%</div>
            <div class="d-flex justify-content-end minMaxWidth" [ngStyle]="{'width':usedPercent+'%'}">{{usedPercent}}%</div>
            <div class="d-flex justify-content-end minMaxWidth" [ngStyle]="{'width':expiredPercent+'%'}">{{expiredPercent}}%</div>
          </div>

          <div class="d-flex bar-progress">
            <div class="available-bar-container" [ngStyle]="{'width':availablePercent+'%'}">
              <div class="available-bar w-100" matTooltip="{{amountLeft}} INR" matTooltipClass="tooltip-admin-percentage"></div>
            </div>
            <div class="used-bar-container" [ngStyle]="{'width':usedPercent+'%'}">
              <div class="used-bar w-100" matTooltip="{{amountRedeem}} INR" matTooltipClass="tooltip-admin-percentage"></div>
            </div>
            <div class="expired-bar" [ngStyle]="{'width':expiredPercent+'%'}" matTooltip="{{amountExpired}} INR" matTooltipClass="tooltip-admin-percentage"></div>
          </div>
        </mat-card>
      </div>
    </div>
  </div>

  <div>
    <span class="walletHeading mb-2"> Reward Distribution </span>
    <div>
      <div class="row">
        <div class="row col-lg-8">
          <div class="col-sm-12 col-md-12 col-lg-6">
            <mat-card class="p-0 card m-2 p-3">
              <mat-card-title class="rewardHeading">
                Amount Distributed
              </mat-card-title>
              <mat-card-subtitle class="rewardSubtitle">
                ₹ {{ amountDistribution | numberFormatter }}
              </mat-card-subtitle>
            </mat-card>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-6">
            <mat-card class="p-0 card m-2 p-3">
              <mat-card-title class="rewardHeading">
                Amount Redeemed
              </mat-card-title>
              <mat-card-subtitle class="rewardSubtitle">
                ₹ {{ amountRedeem  | numberFormatter}}
              </mat-card-subtitle>
            </mat-card>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-6">
            <mat-card class="p-0 card m-2 p-3">
              <mat-card-title class="rewardHeading"> Amount Left </mat-card-title>
              <mat-card-subtitle class="rewardSubtitle">
                ₹ {{ amountLeft | numberFormatter}}
              </mat-card-subtitle>
            </mat-card>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-6">
            <mat-card class="p-0 card m-2 p-3">
              <mat-card-title class="rewardHeading"> Amount Expired </mat-card-title>
              <mat-card-subtitle class="rewardSubtitle">
                ₹ {{ amountExpired | numberFormatter}}
              </mat-card-subtitle>
            </mat-card>
          </div>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-4 d-flex flex-column">
          <mat-card class="card dwntime-card m-2 p-3" *ngIf="scheduleDowntime; else cancelScheduledRedemp">
            <mat-card-title class="rewardHeading mb-2"> Redemption Downtime </mat-card-title>
            <mat-card-content>
              Initiate maintenance immediately or schedule for a later time
            </mat-card-content>
            <mat-card-subtitle class="d-flex align-items-center justify-content-center ">
              <button class="btn-bg-blue d-flex align-items-center" mat-raised-button (click)="openDowntimeModal()">
                <img class="mr-2 " src="assets/images/schedule-downtime.svg"/>
                Schedule
              </button>
            </mat-card-subtitle>
          </mat-card>
          <ng-template #cancelScheduledRedemp>
            <mat-card class="card-blue dwntime-card m-2 p-3" *ngIf="!endDowntime; else endNow">
              <mat-card-title class="rewardHeading mb-2 text-white"> Downtime Scheduled </mat-card-title>
              <mat-card-content class="color-white">
                <div class="d-flex-justify-content-center">Scheduled For:</div>
                <div
                class="d-flex align-items-center justify-content-center mt-2"
              >
                <span class="d-flex align-items-center mr-3">
                  <mat-icon class="mr-1 icon">calendar_today</mat-icon>
                  <span>{{ downtimeData.redemptionDowntimeDetails.fromDate | date: 'dd/MM/yyyy'}}</span>
                </span>
                <span class="d-flex align-items-center">
                  <mat-icon class="mr-1 icon">access_time</mat-icon>
                  <span>{{ downtimeData.redemptionDowntimeDetails.fromDate | date:'HH:mm' }}</span>
                </span>
              </div>
              </mat-card-content>
              <mat-card-subtitle class="d-flex align-items-center justify-content-center ">
                <button class="btn-bg-white d-flex align-items-center" mat-raised-button (click)="openConfirmationModal(false)">
                  Cancel
                </button>
              </mat-card-subtitle>
            </mat-card>
          </ng-template>
          <ng-template #endNow>
            <mat-card class="card-blue dwntime-card m-2 p-3">
              <mat-card-title class="rewardHeading mb-2 text-white"> Redemption is Down </mat-card-title>
              <mat-card-content class="color-white">
                <div class="d-flex justify-content-center">Started On:</div>
                <div
                class="d-flex align-items-center justify-content-center mt-2"
              >
                <span class="d-flex align-items-center mr-3">
                  <mat-icon class="mr-1 icon">calendar_today</mat-icon>
                  <span>{{ downtimeData.redemptionDowntimeDetails.fromDate | date: 'dd/MM/yyyy'}}</span>
                </span>
                <span class="d-flex align-items-center">
                  <mat-icon class="mr-1 icon">access_time</mat-icon>
                  <span>{{ downtimeData.redemptionDowntimeDetails.fromDate | date:'HH:mm' }}</span>
                </span>
              </div>
              </mat-card-content>
              <mat-card-subtitle class="d-flex align-items-center justify-content-center ">
                <button class="btn-bg-white d-flex align-items-center" mat-raised-button (click)="openConfirmationModal(true)">
                  End Now
                </button>
              </mat-card-subtitle>
            </mat-card>
          </ng-template>
        </div>
      </div>
    </div>
  </div>

  <mat-card class="p-0 main-section">
    <div
      *ngIf="this.commonService.getBudgetAddBtnClicked()"
      class="pl-4 pt-4 pb-1 brand-back-btn-text text-style"
      (click)="navigateToRewardDistributionHistory()"
    >
      <mat-icon class="brand-back-btn">keyboard_arrow_left</mat-icon>
      Go back to Reward Distribution History
    </div>
    <div class="d-flex mt-2 ml-2 mb-2 py-4 px-3">
      <div class="d-flex align-items-center distribution-history-title">
        To allocate the budget and occasional rewards:
      </div>
      <div
        class="d-flex justify-content-end"
        *ngIf="!this.commonService.getBudgetAddBtnClicked()"
      >
        <button
          *ngIf="!mobile"
          class="add-new-btn btn-bg-blue ml-3"
          mat-raised-button
          (click)="AddBtnClicked()"
          [disabled]="disableAddNew"
        >
          ADD NEW
        </button>
        <div
          *ngIf="mobile"
          mat-raised-button
          id="add_btn_mobile"
          (click)="AddBtnClicked()"
          [ngClass]="{ 'disabled-style': disableAddNew }"
        >
          <img src="../../../../../assets/images/add_.png" />
        </div>
      </div>
    </div>
    <app-budget-reward-tabs
      *ngIf="!this.commonService.getBudgetAddBtnClicked()"
    >
    </app-budget-reward-tabs>
    <div *ngIf="this.commonService.getBudgetAddBtnClicked()">
      <form [formGroup]="allotmentTypeForm">
        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-4 click">
          <mat-form-field class="w-100" appearance="fill">
            <mat-label class="label-text">Allotment Type</mat-label>
            <mat-select
              formControlName="allotmentData"
              placeholder="Select"
              disableOptionCentering
              (selectionChange)="setAllotmentTypeinService()"
            >
              <mat-option class="input-text" value="budget">
                Allot Budget
              </mat-option>
              <mat-option class="input-text" value="reward">
                Allot Occasional Reward
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </form>
      <div class="p-3" *ngIf="isAllotmentTypeBudget()">
        <app-budgeting-section > </app-budgeting-section>
      </div>
      <div *ngIf="isAllotmentTypeReward()">
        <app-reward-section> </app-reward-section>
      </div>
    </div>
  </mat-card>
</div>
